import { render, staticRenderFns } from "./InductionManagementForm.vue?vue&type=template&id=40ec67b1&scoped=true"
import script from "./InductionManagementForm.vue?vue&type=script&lang=js"
export * from "./InductionManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec67b1",
  null
  
)

export default component.exports